/* Path → workspace map. Config, not a component, so it stays a flat file.

   This is the only place that changes when a workspace is added: each workspace
   module exports its own WorkspaceDef, so g-header and g-rail never learn which
   workspaces exist. Dependencies run layout → workspace, never the reverse.

   Order matters: it's the rail order, and the first entry is the default route. */

import type { TabAction, TabItem, WorkspaceDef } from '../core/types.js';

import { libraryDef } from '../workspace/g-library/g-library.js';
import { mapDef } from '../workspace/g-map/g-map.js';
import { indexDef } from '../workspace/g-index/g-index.js';
import { settingsDef } from '../workspace/g-settings/g-settings.js';

export const WORKSPACES: WorkspaceDef[] = [
  libraryDef,
  mapDef,
  indexDef,
  settingsDef,
];

export const byId = (id: string): WorkspaceDef | undefined =>
  WORKSPACES.find((w) => w.id === id);

/** The tab bar's search entry. See TabAction and ADR 0019. */
export const SEARCH_TAB: TabAction = {
  kind: 'action',
  id: 'search',
  label: 'Search',
  icon: 'search',
};

/**
 * Tab-bar order, which is deliberately NOT the rail's.
 *
 * A second ordering rather than a flag on WORKSPACES, because the action is not
 * a route and the rail must never be handed one. Search sits in the centre: the
 * easiest point to reach on a 360px screen, and the bar's only entry that is an
 * action rather than a place.
 */
export const TABS: TabItem[] = [
  libraryDef,
  mapDef,
  SEARCH_TAB,
  indexDef,
  settingsDef,
];
